<template>
  <ConfirmDeleteConfigurationSftpModal />
  <div class="modal fade close-generate-token-modal" id="CreateOrUpdateConfigurationModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Configuração SFTP</h1>
                  <button type="button" class="btn-close close-generate-token-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

                <form ref="formConfigurationSftp" v-on:submit="saveConfigurationSftpMethod()">

                  <div class="modal-body ps-30 pe-30">

                    <div class="mt-30" id="myTabContentSftp">
                      <div
                        class="show active row"
                        id="overviewPreview-tab-pane"
                        role="tabpanel"
                        tabindex="0"
                      >
                        <input :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.id : null" class="d-none" id="id_sftp"/>

                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="host" class="form-label fw-medium"
                            >Nome da conexão</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.name : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="name_sftp"
                            autocomplete="off"
                            required
                          />
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="host" class="form-label fw-medium"
                            >Host</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.host : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="host"
                            autocomplete="off"
                            required
                          />
                        </div>
                        
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="port" class="form-label fw-medium"
                            >Port</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.port : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="port"
                            autocomplete="off"
                            required
                          />
                        </div>
                        
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="user" class="form-label fw-medium"
                            >User</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.user : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="user"
                            autocomplete="off"
                            required
                          />
                        </div>
                        
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="password_sftp" class="form-label fw-medium"
                            >Password</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.password : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="password_sftp"
                            autocomplete="off"
                            required
                          />
                        </div>

                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="password_sftp" class="form-label fw-medium">
                            Chave SSH (Opcional)
                          </label>
                          <input
                            ref="sshKeyInput"
                            :title="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.ssh_key_name : ''"
                            type="file"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="chave_ssh"
                            autocomplete="off"
                            accept=".pem,.ppk,.pub"
                          />
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="remote_path" class="form-label fw-medium"
                            >Diretório das gravações</label
                          >
                          <input
                            :value="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.remote_path : ''"
                            type="text"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                            id="remote_path"
                            autocomplete="off"
                            required
                          />
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="delete_files" class="form-label fw-medium"
                            >Deletar arquivos no servidor remoto após upload ?</label
                          >
            
                          <select id="delete_files" class="form-select shadow-none text-black fs-md-15" required>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.delete_files == '1' : false" value="1">Sim</option>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.delete_files == '0' : false" value="0">Não</option>
                          </select>
            
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="interval_minutes" class="form-label fw-medium"
                            >Intervalo de minutos para uploads</label
                          >
            
                          <select id="interval_minutes" class="form-select shadow-none text-black fs-md-15" required>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.interval_minutes == '15' : false" value="15">15 minutos</option>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.interval_minutes == '30' : false" value="30">30 minutos</option>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.interval_minutes == '60' : false" value="60">1 hora</option>
                          </select>
            
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                          <label for="active" class="form-label fw-medium"
                            >Status da configuração</label
                          >
                          
                          <select id="active" class="form-select shadow-none text-black fs-md-15" required>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.active == '1' : false" value="1">Ativo</option>
                            <option :selected="getCurrentConfigurationSftp != undefined ? getCurrentConfigurationSftp.active == '0' : false" value="0">Inativo</option>
                          </select>
            
                        </div>
            
                        <div class="mb-15 mb-mb-15 mb-md-20 col-12">
                          <label for="remote_path" class="form-label fw-medium"
                            >Senha do sistema</label
                          >
                          <input
                            type="password"
                            class="form-control shadow-none text-black fs-md-15 fs-lg-16 col-12"
                            id="password_account"
                            autocomplete="off"
                            required
                          />
                        </div>
            
                        <div class="col-12">
                          <div id="alertResponseApiSftp" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                            <div class="d-flex">
                              <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageSftp">
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                  </div>
                  
                  <div class="modal-footer">
                    <button type="submit" @click="saveConfigurationSftpMethod" ref="buttonSubmitConfigurationUpdateSftp" class="btn btn-success">Salvar</button>
                    <button v-if="getCurrentConfigurationSftp != null" type="button" data-bs-toggle="modal" data-bs-target="#ConfirmDeleteConfigurationSftpModal" class="btn btn-dark close-generate-token-modal">Deletar</button>
                    <button type="button" class="btn btn-danger close-generate-token-modal" data-bs-dismiss="modal">Cancelar</button>
                  </div>

                </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '../../config/axios.js';
import ConfirmDeleteConfigurationSftpModal from './ConfirmDeleteConfigurationSftpModal.vue';

export default {
  name: "CreateOrUpdateConfigurationModal",
  data () {
    return {
      loadingAudioPlayer: false,
      errorMessage: ""
    }
  },
  components: {
    ConfirmDeleteConfigurationSftpModal
  },
  computed:{
    ...mapGetters([
        'getCurrentRecording',
        'getCurrentUrlRecording',
        'getRecordingShowModalState',
        'getCurrentConfigurationSftp'
    ])
  },
  methods: {
    ...mapActions([
      "setNewToken"
    ]),
    saveConfigurationSftpMethod(){
      event.preventDefault();

      if(
        !this.$route.params.id ||
        document.getElementById("name_sftp") == undefined ||
        document.getElementById("name_sftp").value == "" ||
        document.getElementById("host") == undefined ||
        document.getElementById("host").value == "" ||
        document.getElementById("port") == undefined ||
        document.getElementById("port").value == "" ||
        document.getElementById("user") == undefined ||
        document.getElementById("user").value == "" ||
        document.getElementById("remote_path") == undefined ||
        document.getElementById("remote_path").value == "" ||
        document.getElementById("delete_files") == undefined ||
        document.getElementById("delete_files").value == "" ||
        document.getElementById("interval_minutes") == undefined ||
        document.getElementById("interval_minutes").value == "" ||
        document.getElementById("active") == undefined ||
        document.getElementById("active").value == "" ||
        document.getElementById("password_account") == undefined ||
        document.getElementById("password_account").value == ""
      ){
        this.alertResponse("Erro, verifique os campos e tente novamente !", true);
        return;
      }

      if( document.getElementById("password_sftp").value == "" && document.getElementById("chave_ssh").value == ""){
        this.alertResponse("O campo de Password ou chave ssh precisam ser preenchidos", true);
        return;
      }

      const operation_id = this.$route.params.id;
      const id_sftp = document.getElementById("id_sftp").value;
      const name_sftp = document.getElementById("name_sftp").value;
      const host = document.getElementById("host").value;
      const port = document.getElementById("port").value;
      const user = document.getElementById("user").value;
      const password_sftp = document.getElementById("password_sftp").value;
      const remote_path = document.getElementById("remote_path").value;
      const delete_files = document.getElementById("delete_files").value;
      const interval_minutes = document.getElementById("interval_minutes").value;
      const active = document.getElementById("active").value;
      const password_account = document.getElementById("password_account").value;

      const configurationSftp = {
        "id": id_sftp,
        "operation_id": operation_id,
        "name_sftp": name_sftp,
        "host": host,
        "port": port,
        "user": user,
        "password_sftp": password_sftp,
        "remote_path": remote_path,
        "delete_files": delete_files,
        "interval_minutes": interval_minutes,
        "active": active,
        "password_account": password_account,
      }

      const fileInput = this.$refs.sshKeyInput;
      const file = fileInput.files[0];

      const buttonSubmitConfigurationUpdateSftp = this.$refs.buttonSubmitConfigurationUpdateSftp;
      buttonSubmitConfigurationUpdateSftp.disabled = true;
      buttonSubmitConfigurationUpdateSftp.innerHTML = "Salvando...";

        const formData = new FormData();
        formData.append('configurationSftp', JSON.stringify(configurationSftp));
        if (file) {
            formData.append('sshKey', file);
        }

        api.axios.post('/api/save/configurations/sftp', formData).catch(function(error){
          if(error.response.data != undefined){
            buttonSubmitConfigurationUpdateSftp.innerHTML = "Salvar configuração";
          }
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonSubmitConfigurationUpdateSftp.innerHTML = "Alterações salvas com sucesso !";
            window.location.reload();
          } else {
            buttonSubmitConfigurationUpdateSftp.disabled = false;
            buttonSubmitConfigurationUpdateSftp.innerHTML = "Salvar configuração";
            document.getElementById("password_account").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageSftp").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageSftp").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiSftp");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 3000);
      }

      const password = document.getElementById("password_account");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>